<template>
  <div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Submit a Question</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            <label>
              Please enter your question below.
            </label>
            <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
          </div>
          <div class="form-group h-full flex flex-col">
            <label>Upload Attachments</label>
            <form :action="`${$aws_upload_url}`" method="post"
                  enctype="multipart/form-data" id="amazon_form">
              <input type="hidden" name="policy" :value="aws_policy">
              <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
              <input type="hidden" name="x-amz-credential" :value="aws_credential">
              <input type="hidden" name="x-amz-date" :value="aws_date">
              <input type="hidden" name="x-amz-signature" :value="aws_signature">
              <input type="hidden" name="acl" value="private">
            </form>
            <vue-dropzone
                ref="fileUploadDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-file-added="fileAddedToDropZone"
                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                :useCustomSlot="true"
            >
              <div>
                <div class="mb-3">
                  DRAG AND DROP FILE
                </div>
                <div class="mb-3">
                  OR
                </div>
                <div>
                  <a class="btn-secondary-outline">
                    Choose a file
                  </a>
                </div>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiryMessage()">
            Send
          </a>
        </div>
      </div>
    </div>
    <div class="faqs-coming-soon-banner" v-if="selected_faq_type_id === 2">
      Coming Soon! Help us build this section by submitting any questions you have about Connect
      <div class="mt-6">
        <a class="btn-primary-outline" @click="enquiry_box_open = true">Ask a Question</a>
      </div>
    </div>
    <div class="main-faqs-page-wrapper" v-if="selected_faq_type_id === 1">
      <main class="faqs-wrapper">
        <div class="faq-categories">
          <div v-for="(faq_category) in faq_categories" class="faq-category">
            <div class="faq-category-header" @click="toggleOpenFaqCategory(faq_category.label)">
              <h2 class="faq-category-label">{{ faq_category.label }}</h2>
              <div class="faq-category-toggle">
                <i class="fal fa-chevron-up" v-if="open_faq_categories.includes(faq_category.label)"></i>
                <i class="fal fa-chevron-down" v-if="!open_faq_categories.includes(faq_category.label)"></i>
              </div>
            </div>
            <div class="faqs" v-show="open_faq_categories.includes(faq_category.label)">
              <div v-for="faq in faq_category.faqs" class="faq">
                <div class="faq-header">
                  <div class="letter-aside">
                    Q.
                  </div>
                  <h3 class="faq-question">{{ faq.question }}</h3>
                </div>
                <div class="faq-answer-wrapper">
                  <div class="letter-aside">
                    A.
                  </div>
                  <div class="faq-answer" v-html="faq.answer"></div>
                </div>
              </div>
              <div v-if="faq_category.faqs.length === 0" class="p-6">
                No FAQs found
              </div>
            </div>
          </div>
        </div>
      </main>
      <aside class="faqs-sidebar-wrapper">
        <div class="faqs-sidebar">
          <div class="category-list">
            <div class="title">
              Categories
            </div>
            <div class="category"
                 @click="selected_faq_category_id = null"
                 :class="{ '_active' :  selected_faq_category_id === null}">
              All
            </div>
            <div class="category"
                 v-for="category in all_faq_categories"
                 @click="selected_faq_category_id = category.id"
                 :class="{ '_active' :  selected_faq_category_id === category.id}">
              {{ category.label }}
            </div>
          </div>
          <div class="faqs-search">
            <div class="form-group">
              <input type="text" placeholder="Search" class="form-control _slim" v-model="search_query">
            </div>
          </div>
        </div>
      </aside>
    </div>
    <div class="box ml-3 mr-3" v-if="selected_faq_type_id === 1">
      <div class="flex justify-between">
        <div class="p-3 flex flex-col justify-around">
          Can't find the answer you're looking for? Ask a new question.
        </div>
        <div class="p-3">
          <a class="btn-primary" @click="enquiry_box_open = true">Ask a Question</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vue2Dropzone from "vue2-dropzone";

export default {
  props: [
      'selected_faq_type_id',
    'aws_policy',
    'aws_credential',
    'aws_date',
    'aws_signature'
  ],
  components: {
    'vue-dropzone': vue2Dropzone,
  },
  data() {
    return {
      faq_categories: [],
      all_faq_categories: [],
      loading: true,
      selected_faq_category_id: null,
      search_query: '',
      open_faq_categories: [],
      enquiry_box_open: false,
      enquiry_message: '',
      sending: false,
      saving_file: false,
      uploaded_file: null,
      attachments: [],
      attachment_info: [],
      saving_file_number: 0,
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        uploadMultiple: true,
        addRemoveLinks: true,
      },
    };
  },
  computed: {
  },
  mounted() {
    this.loadFaqCategories();
    this.loadFaqs();
  },
  methods: {
    loadFaqCategories: _.debounce(function () {
      axios.post('/faqs/loadCategories', {
        faq_type_id: this.selected_faq_type_id,
      }).then((response) => {
        this.all_faq_categories = response.data;
        // this.all_faq_categories.forEach((category) => {
        //   this.open_faq_categories.push(category.label);
        // })
      });
    }, 250),
    loadFaqs: _.debounce(function () {
      axios.post('/faqs/loadFaqsForCustomer', {
        faq_type_id: this.selected_faq_type_id,
        faq_category_id: this.selected_faq_category_id,
        search_query: this.search_query,
      }).then((response) => {
        this.faq_categories = response.data;
        this.loading = false;
      });
    }, 250),
    toggleOpenFaqType(faq_type_id) {
      if(this.open_faq_types.includes(faq_type_id)) {
        let index = this.open_faq_types.indexOf(faq_type_id);
        if (index > -1) {
          this.open_faq_types.splice(index, 1);
        }
      } else {
        this.open_faq_types.push(faq_type_id);
      }
    },
    toggleOpenFaqCategory(faq_category_id) {
      if(this.open_faq_categories.includes(faq_category_id)) {
        let index = this.open_faq_categories.indexOf(faq_category_id);
        if (index > -1) {
          this.open_faq_categories.splice(index, 1);
        }
      } else {
        this.open_faq_categories.push(faq_category_id);
      }
    },
    fileAddedToDropZone(uploadedFile) {
      const extension = uploadedFile.name.replace(/^.*\./, '');
      const original_file_name = uploadedFile.name.replace('.' + extension, '');

      let new_upload = {};

      new_upload.name = original_file_name;
      const filename = 'enquiry_attachments/' + original_file_name + '_' + Date.now();
      new_upload.filename = filename + '.' + extension;

      if (extension.toLowerCase() === 'svg') {
        new_upload.thumbnail_url = new_upload.filename;
      } else {
        new_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
      }

      new_upload.filetype = uploadedFile.type;
      new_upload.uploaded_file = uploadedFile;
      new_upload.original_file_name = original_file_name;
      new_upload.file_url = filename;

      this.attachments.push(new_upload);
      this.attachment_info.push({
        original_file_name: original_file_name,
        filename: filename + '.' + extension,
      });
    },
    fileRemovedFromDropZone(file) {
      const extension = file.name.replace(/^.*\./, '');
      const original_file_name = file.name.replace('.' + extension, '');
      this.attachments = this.attachments.filter(attachment => attachment.original_file_name !== original_file_name);
      this.attachment_info = this.attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
    },
    sendEnquiry() {
      this.saving_file = false;
      this.saving_file_number = 0;
      this.sending = true;
      this.enquiry_box_open = false;

      let enquiry_type_id = 29;
      if(this.selected_faq_type_id === 1) {
        enquiry_type_id = 29; //new building regs
      }

      if(this.selected_faq_type_id === 2) {
        enquiry_type_id = 30; //general faqs
      }

      axios.post('/enquiry/send', {
        enquiry_type_id: enquiry_type_id,
        message: this.enquiry_message,
        attachments: this.attachment_info,
      }).then((response) => {

        if(this.selected_faq_type_id === 1) {
          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'New Building Regulations Question',
            'value': 'New Building Regulations Question',
          });
        }

        if(this.selected_faq_type_id === 2) {
          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'FAQ Question',
            'value': 'FAQ Question',
          });
        }

        this.enquiry_message = '';
        this.sending = false;
        this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
        this.attachments = [];
        this.attachment_info = [];

        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Your enquiry has been submitted, you will be sent a notification when you receive a reply.'
        });
      });
    },
    async sendEnquiryMessage() {

      this.sending = true;

      const validationErrors = Validate({
        message: this.enquiry_message,
      }, {
        message: {
          presence: {
            allowEmpty: false,
          },
        },
      });

      if (validationErrors) {
        this.sending = false;
        Swal.fire({
          title: 'Please enter a question',
          icon: 'error',
        });
        return;
      }

      if(this.attachments.length === 0) {
        this.sendEnquiry();
      } else {
        this.enquiry_box_open = false;
        this.saving_file_number = 1;

        await this.attachments.forEach(async (upload, index) => {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('Content-Type', upload.filetype);
          form_data.append('key', upload.filename);
          form_data.append('file', upload.uploaded_file);

          await axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(async () => {

            if(this.saving_file_number === this.attachments.length) {
              this.sendEnquiry();
            } else {
              this.saving_file_number = this.saving_file_number + 1;
            }

          });
        });
      }

    },
  },
  watch: {
    selected_faq_category_id() {
      this.loadFaqs();
    },
    selected_faq_type_id() {
      this.loadFaqCategories();
      this.loadFaqs();
    },
    search_query() {
      this.loadFaqs();
    },
  },
};
</script>
